<template>
  <div v-if="open" class="ds-popover">
    <h3 v-if="!!title" class="ds-popover--title">{{ title }}</h3>
    <p class="ds-popover--content">
      {{ content }}
    </p>
    <div
      class="ds-popover--footer"
      :class="{ 'ds-popover--footer-no-title': !!title }"
    >
      <a
        :href="href"
        class="ds-popover--secondary-action"
        @click="secondaryAction"
      >
        {{ secondaryActionLabel }}
      </a>
      <button
        v-if="!!primaryActionLabel"
        class="ds-popover--primary-action"
        @click="primaryAction"
      >
        {{ primaryActionLabel }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'Popover',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    primaryActionLabel: {
      type: String,
      default: ''
    },
    primaryAction: {
      type: Function,
      default: () => ({})
    },
    secondaryActionLabel: {
      type: String,
      default: ''
    },
    secondaryAction: {
      type: Function,
      default: () => ({})
    }
  }
});
</script>

<style lang="scss" scoped>
@import '~@ds/styles/Popover.scss';
</style>
